module.exports = __webpack_public_path__ + "static/category-f6a2c3597c24d3751c169cdb54f7d020.png";